'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, stage_id, item, before_id, after_id) {
  return function (dispatch) {
    var _dispatch;

    return dispatch((_dispatch = {
      feis_id: feis_id,
      stage_id: stage_id,
      item: item

    }, _defineProperty(_dispatch, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/' + stage_id + '/attach-' + (item.placeholder ? 'placeholder' : 'event'),
        method: 'POST',
        data: {
          before_id: before_id,
          after_id: after_id,
          event_id: item.placeholder ? undefined : item.id
        }
      },
      types: ['ATTACH_EVENT_TO_STAGE_START', 'ATTACH_EVENT_TO_STAGE', 'ATTACH_EVENT_TO_STAGE_ERROR']
    }), _defineProperty(_dispatch, 'meta', {
      before_id: before_id,
      after_id: after_id
    }), _dispatch));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/attachEvent.js
// module id = 242
// module chunks = 0